<template>
  <div class="kr-decreasing-warning">
    <i class="el-icon-warning-outline kr-decreasing-warning-icon" />
    <div>
      <div>{{ $t('performance.goals.tracking_individual_decreasing_warning') }}</div>
      <div class="kr-decreasing-warning-hint">{{ $t('performance.goals.tracking_decreasing_reframe_hint') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KrDecreasingWarning',
}
</script>

<style scoped>
.kr-decreasing-warning {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  background: #fff7e6;
  border: 1px solid #f7d9a1;
  border-radius: 6px;
  color: #7a5200;
  font-size: 12px;
  line-height: 1.45;
}

.kr-decreasing-warning-icon {
  color: #F7B924;
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 1px;
}

.kr-decreasing-warning-hint {
  color: #8a6a2c;
  margin-top: 4px;
}
</style>
